<template>
  <div class="system-params">

    <form class="params-form" @submit.prevent="formSubmit">
      <div class="toggle-grid">
        <label class="toggle-item">
          <span>buysAllowed</span>
          <label class="switch">
            <input type="checkbox" v-model="formData.buysAllowed" />
            <span class="slider"></span>
          </label>
        </label>

        <label class="toggle-item">
          <span>sellsAllowed</span>
          <label class="switch">
            <input type="checkbox" v-model="formData.sellsAllowed" />
            <span class="slider"></span>
          </label>
        </label>

        <label class="toggle-item">
          <span>rebuyBuysAllowed</span>
          <label class="switch">
            <input type="checkbox" v-model="formData.rebuyBuysAllowed" />
            <span class="slider"></span>
          </label>
        </label>

        <label class="toggle-item">
          <span>rebuySellsAllowed</span>
          <label class="switch">
            <input type="checkbox" v-model="formData.rebuySellsAllowed" />
            <span class="slider"></span>
          </label>
        </label>
      </div>

      <div class="inputs-group">
        <div class="inputs-grid">

          <div class="form-group">
            <label>Bias</label>
            <input type="number" v-model.number="formData.controller.biasConviction" step="0.000001" min="0" />
          </div>

          <div class="form-group">
            <label>Support</label>
            <input type="number" v-model.number="formData.controller.supportPrice" step="0.000001" min="0" />
          </div>

          <div class="form-group">
            <label>Resistance</label>
            <input type="number" v-model.number="formData.controller.resistancePrice" step="0.000001" min="0" />
          </div>

        </div>
      </div>

      <div class="inputs-group">
        <div class="inputs-grid">

          <!-- <div class="form-group">
            <label>spreadDeals</label>
            <input type="number" v-model.number="formData.spreadDeals" step="0.01" min="0" />
          </div>

          <div class="form-group">
            <label>rebuyDiscount</label>
            <input type="number" v-model.number="formData.rebuyDiscount" step="0.01" min="0" />
          </div> -->

          <div class="form-group">
            <label>maxRegularsMCA</label>
            <input type="number" v-model.number="formData.controller.maxRegularsMCA" step="0.000001" min="5" />
          </div>

          <div class="form-group">
            <label>gridSize</label>
            <input type="number" v-model.number="formData.controller.gridSize" step="0.000001" min="5" />
          </div>

          <div class="form-group">
            <label>maxRebuysLLP</label>
            <input type="number" v-model.number="formData.controller.maxRebuysLLP" step="0.000001" min="5" />
          </div>

          <div class="form-group">
            <label>maxBandFraction</label>
            <input type="number" v-model.number="formData.controller.maxBandFraction" step="0.01" min="0.01" max="1" />
          </div>

        </div>
      </div>

      <div class="inputs-group proportion-health">
        <div class="proportion-title">Proporção de Banda</div>
        <div class="proportion-grid">
          <div class="proportion-item">
            <span class="proportion-label">Budget base/banda</span>
            <span class="proportion-value">${{ bandProportion.base.toFixed(2) }}</span>
          </div>
          <div class="proportion-item">
            <span class="proportion-label">Budget max/banda (B=1)</span>
            <span class="proportion-value">${{ bandProportion.max.toFixed(2) }}</span>
          </div>
          <div class="proportion-item">
            <span class="proportion-label">Multiplicador (auto)</span>
            <span class="proportion-value" :class="bandMultClass">{{ bandProportion.mult.toFixed(2) }}x</span>
          </div>
          <div class="proportion-item">
            <span class="proportion-label">Bandas no range</span>
            <span class="proportion-value">{{ bandProportion.numBands }}</span>
          </div>
        </div>
        <div v-if="bandProportion.warning" class="proportion-warning">{{ bandProportion.warning }}</div>
      </div>

      <button type="submit">Salvar</button>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'systemParametersForm',
  data() {
    return {
      formData: {
        buysAllowed: false,
        sellsAllowed: false,
        rebuyBuysAllowed: false,
        rebuySellsAllowed: false,
        controller: {
          biasConviction: 0,
          supportPrice: 0,
          resistancePrice: 0,
          maxRegularsMCA: 0,
          gridSize: 0,
          maxRebuysLLP: 0,
          maxBandFraction: 0.10,
          maxBandMultiplierCap: 6.0,
        }
      },
    };
  },
  computed: {
    ...mapState({ systemInfos: state => state.systemInfos }),
    strategyParams() { return this.systemInfos?.strategyParams || {} },
    bandProportion() {
      const { maxRegularsMCA, gridSize, supportPrice, resistancePrice, maxBandFraction, maxBandMultiplierCap } = this.formData.controller;
      const range    = (resistancePrice || 0) - (supportPrice || 0);
      const numBands = gridSize > 0 && range > 0 ? range / gridSize : 0;
      const base     = numBands > 0 ? (maxRegularsMCA || 0) / numBands : 0;
      const max      = (maxRegularsMCA || 0) * (maxBandFraction || 0.10);
      const mult     = numBands > 0 ? (maxBandFraction || 0.10) * numBands : 0;
      const cap      = maxBandMultiplierCap || 6.0;

      let warning = null;
      if (numBands === 0) warning = 'Configure o range e o gridSize.';
      else if (mult > cap) warning = `Multiplicador ${mult.toFixed(1)}x excede o cap de ${cap}x. Reduza o range ou aumente o gridSize.`;
      else if (base < 30) warning = `Budget base/banda ($${base.toFixed(0)}) está muito baixo. Considere reduzir o range ou aumentar o maxRegularsMCA.`;

      return { base, max, mult, numBands: Math.round(numBands), warning };
    },
    bandMultClass() {
      const { mult } = this.bandProportion;
      if (mult <= 2.0) return 'mult-ok';
      if (mult <= 4.0) return 'mult-warn';
      return 'mult-danger';
    },
  },
  watch: {
    strategyParams: {
      immediate: true,
      handler(newParams) {
        this.formData = {
          buysAllowed: !!newParams.buysAllowed,
          sellsAllowed: !!newParams.sellsAllowed,
          rebuyBuysAllowed: !!newParams.rebuyBuysAllowed,
          rebuySellsAllowed: !!newParams.rebuySellsAllowed,
          controller: {
            biasConviction: Number(newParams.controller?.biasConviction ?? 0),
            supportPrice: Number(newParams.controller?.supportPrice ?? 0),
            resistancePrice: Number(newParams.controller?.resistancePrice ?? 0),
            maxRegularsMCA: Number(newParams.controller?.maxRegularsMCA ?? 0),
            gridSize: Number(newParams.controller?.gridSize ?? 0),
            maxRebuysLLP: Number(newParams.controller?.maxRebuysLLP ?? 0),
            maxBandFraction: Number(newParams.controller?.maxBandFraction ?? 0.10),
            maxBandMultiplierCap: Number(newParams.controller?.maxBandMultiplierCap ?? 6.0),
          }
        };
      }
    }
  },
  methods: {
    formSubmit() {
      const req = {
        type: 'updateSystemParameters',
        systemParameters: { ...this.formData }
      };

      if (this.$store.state.socket) {
        this.$store.state.socket.send(JSON.stringify(req));
      }
    }
  },
}
</script>

<style scoped>
.system-params {
  width: 620px;
}

.params-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.toggle-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 20px;
}

.toggle-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.toggle-item span {
  font-size: 16px;
}

.inputs-group {
  width: 100%;
  float: left;
  margin: 20px 0;
  border-bottom: 1px dashed #505050;
}

.proportion-health {
  border-bottom: none;
  margin: 0;
}

.proportion-title {
  font-size: 13px;
  color: #888;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.proportion-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px 20px;
  margin-bottom: 8px;
}

.proportion-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.proportion-label {
  font-size: 12px;
  color: #888;
}

.proportion-value {
  font-size: 15px;
  font-weight: 600;
}

.mult-ok     { color: #00E396; }
.mult-warn   { color: #FEB019; }
.mult-danger { color: #FF4560; }

.proportion-warning {
  font-size: 13px;
  color: #FF4560;
  padding: 6px 0;
}

.inputs-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group input {
  padding: 10px 8px;
  font-size: 16px !important;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 40px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .2s;
  border-radius: 999px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: .2s;
  border-radius: 50%;
}

.switch input:checked + .slider {
  background-color: #2f7ef7;
}

.switch input:checked + .slider:before {
  transform: translateX(18px);
}
</style>
